// @flow
import React, { Component } from 'react'
import styled from 'styled-components'
import FloatPanel from './FloatPanel'
import VerticallyCentralizedItems from './VerticallyCentralizedItems'
import PrimaryButton from './PrimaryButton'
import postJson from '../../services/postJson'

const ButtonsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-left: -5px;
`
const ButtonWrapper = styled.div`
  margin-left: 5px;
`

const t = {
  activate: 'Запустить',
  archive: 'Архивировать',
  are_you_sure: 'Вы уверены?',
  deactivate: 'Остановить',
  price_budget_edit: 'Изменить ставку/бюджет',
  text_url_edit: 'Изменить текст/URL'
}

type Props = {|
  isLoading: boolean,
  activateUrl?: string,
  deactivateUrl?: string,
  archiveUrl?: string,
  ids: Array<number>,
  onBeforeRequest: Function,
  onActivateDeactivateSuccess?: Function,
  onArchiveSuccess?: Function,
  onAfterRequest: Function,
  onPriceBudgetEdit?: Function,
  onTextUrlEdit?: Function
|}

export default class MassOperationsFooter extends Component<Props> {
  render() {
    const {
      isLoading,
      activateUrl,
      deactivateUrl,
      archiveUrl,
      onActivateDeactivateSuccess,
      onArchiveSuccess,
      onPriceBudgetEdit,
      onTextUrlEdit
    } = this.props
    return (
      <FloatPanel>
        <div className="container">
          <VerticallyCentralizedItems>
            <ButtonsWrapper>
              {activateUrl && (
                <ButtonWrapper>
                  <PrimaryButton
                    height={32}
                    disabled={isLoading}
                    onClick={() => {
                      this.makeStateChangeRequest(activateUrl, (data, ids) => {
                        onActivateDeactivateSuccess && onActivateDeactivateSuccess(data, ids)
                      })
                    }}
                  >
                    {t.activate}
                  </PrimaryButton>
                </ButtonWrapper>
              )}
              {deactivateUrl && (
                <ButtonWrapper>
                  <PrimaryButton
                    height={32}
                    disabled={isLoading}
                    onClick={() => {
                      this.makeStateChangeRequest(deactivateUrl, (data, ids) => {
                        onActivateDeactivateSuccess && onActivateDeactivateSuccess(data, ids)
                      })
                    }}
                  >
                    {t.deactivate}
                  </PrimaryButton>
                </ButtonWrapper>
              )}
              {archiveUrl && (
                <ButtonWrapper>
                  <PrimaryButton
                    height={32}
                    disabled={isLoading}
                    onClick={() => {
                      this.makeStateChangeRequest(
                        archiveUrl,
                        () => {
                          onArchiveSuccess && onArchiveSuccess()
                        },
                        true
                      )
                    }}
                  >
                    {t.archive}
                  </PrimaryButton>
                </ButtonWrapper>
              )}
              {onPriceBudgetEdit && (
                <ButtonWrapper>
                  <PrimaryButton height={32} disabled={isLoading} onClick={onPriceBudgetEdit}>
                    {t.price_budget_edit}
                  </PrimaryButton>
                </ButtonWrapper>
              )}
              {onTextUrlEdit && (
                <ButtonWrapper>
                  <PrimaryButton height={32} disabled={isLoading} onClick={onTextUrlEdit}>
                    {t.text_url_edit}
                  </PrimaryButton>
                </ButtonWrapper>
              )}
            </ButtonsWrapper>
          </VerticallyCentralizedItems>
        </div>
      </FloatPanel>
    )
  }

  makeStateChangeRequest(url: string, onSuccess: Function, needConfirm?: boolean) {
    const { onBeforeRequest, onAfterRequest, ids } = this.props
    if (needConfirm && !window.confirm(t.are_you_sure)) return
    onBeforeRequest()
    postJson(url, { ids: ids })
      .then((response) => {
        if (response.success) {
          onSuccess(response.data, ids)
        }
      })
      .fail(() => window.alert('Internal error'))
      .always(() => onAfterRequest())
  }
}
